import { createPortal } from "react-dom";
import type { ReactNode } from "react";

/** Renders children as a direct child of `<body>` — required for viewport-sized fixed overlays. */
export function BodyPortal({ children }: { children: ReactNode }) {
  return createPortal(children, document.body);
}
